module.exports = __webpack_public_path__ + "fonts/iconfont.1bb9e75a.woff2";